import { useEffect } from "react";
import { motion } from "framer-motion";
import Navbar from "./Navbar";
import Footer from "./Footer";

export const PageLayout = ({ children, title }) => {
  useEffect(() => {
    if (title) document.title = `${title} · TechTies`;
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [title]);

  return (
    <div className="relative min-h-screen bg-white">
      <Navbar />
      <motion.main
        initial={{ opacity: 0, y: 8 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5, ease: [0.16, 0.84, 0.44, 1] }}
        className="relative z-[2]"
      >
        {children}
      </motion.main>
      <Footer />
    </div>
  );
};

export default PageLayout;
